<template>
  <ReportWrapper>
    <template #actions>
      <div class="flex gap-x-2">
        <CfsDateField v-model="selectedDateRange" placeholder="Select date range" range />
      </div>

      <v-btn color="primary" :disabled="!selectedDateRange" :loading="isLoading" @click="download">
        <v-icon size="1rem" class="mr-1">mdi-tray-arrow-down</v-icon>
        <span>Download</span>
      </v-btn>
    </template>
  </ReportWrapper>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import { downloadFile } from '@/helpers/download';
import { useToast } from '@/composables/useToast';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';
import { AxiosError } from 'axios';

export default defineComponent({
  name: 'FlatInvoiceReport',
  components: {
    ReportWrapper,
  },
  setup() {
    const toast = useToast();

    const selectedCustomer = ref<string | null>(null);
    const selectedDateRange = ref<{ start: string; end: string } | null>(null);

    const { useDownloadFlatInvoiceReport } = useReports();
    const { mutateAsync: downloadReport, isLoading } = useDownloadFlatInvoiceReport();

    const download = async () => {
      try {
        const formatDate = (date: string) => {
          return new Date(date).toISOString().split('T')[0];
        };
        isLoading.value = true;
        const data = await downloadReport({
          'period[start]': selectedDateRange.value?.start
            ? formatDate(selectedDateRange.value.start)
            : '',
          'period[end]': selectedDateRange.value?.end
            ? formatDate(selectedDateRange.value.end)
            : '',
        });

        if (!data) return;

        downloadFile(data.base64Data, data.filename ?? 'Customer Invoices Report');
      } catch (error) {
        const axiosError = error as AxiosError<string>;
        toast.error(axiosError?.response?.data!);
      } finally {
        isLoading.value = false;
        selectedDateRange.value = null;
      }
    };

    return { selectedDateRange, selectedCustomer, isLoading, download };
  },
});
</script>
